import { render, staticRenderFns } from "./SunnyvalePD.vue?vue&type=template&id=6fe9ea70&scoped=true&"
import script from "./SunnyvalePD.vue?vue&type=script&lang=js&"
export * from "./SunnyvalePD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9ea70",
  null
  
)

export default component.exports